export enum TestPackageCount {
  SINGLE = 1,
  DOUBLE = 2,
  TRIPLE = 3,
}

export enum TestPackageSeq {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
}

export interface Student {
  id?: string;
  regId?: string;
  displayedRegNo?: string;
  candFirstName?: string;
  candLastName?: string;
  candMidInit?: string;
  groupType?: string;
  roomName?: string;
  joinCode?: string;
  startPin?: string;
  checkedInRoom?: boolean;
  dapTestStatus?: { name?: string };
  multiDayInd?: boolean;
  testPackageCount?: TestPackageCount;
  testPackageSeq?: TestPackageSeq;
  absent?: boolean;
  deniedEntry?: boolean;
}
